import { useEffect, useState } from "react"
import _ from "lodash"

export const useMousePosition = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 })

  useEffect(() => {
    const setFromEvent = e => setPosition({ x: e.clientX, y: e.clientY })
    window.addEventListener("mousemove", _.throttle(setFromEvent, 100))

    return () => {
      window.removeEventListener("mousemove", _.throttle(setFromEvent, 100))
    }
  }, [])

  return position
}
